import { SubscriptionsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { subscriptionsKeys } from 'app/queries/subscriptions/subscriptionsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof subscriptionsKeys.detail>>;

export const createFetchSubscriptionDetailsQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ subscriptionId }], signal }: TParams) =>
    call(() => cancelOnSignal(SubscriptionsService.adminFindOne({ subscriptionId }), signal));
